import { render, staticRenderFns } from "./LectureWelcomeBox.vue?vue&type=template&id=19f71a8f&scoped=true&"
import script from "./LectureWelcomeBox.vue?vue&type=script&lang=js&"
export * from "./LectureWelcomeBox.vue?vue&type=script&lang=js&"
import style0 from "./LectureWelcomeBox.vue?vue&type=style&index=0&id=19f71a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f71a8f",
  null
  
)

export default component.exports